/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgJiraDisabled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M27.006 4H15.45a5.21 5.21 0 0 0 5.212 5.211h2.125v2.058A5.21 5.21 0 0 0 28 16.48V4.994A.995.995 0 0 0 27.006 4Z",
        fill: "#7A869A"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M21.28 9.76H9.726a5.21 5.21 0 0 0 5.211 5.211h2.126v2.058a5.21 5.21 0 0 0 5.211 5.211V10.754a.995.995 0 0 0-.994-.994Z",
        fill: "url(#JiraDisabled_svg__a)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15.554 15.52H4a5.21 5.21 0 0 0 5.211 5.211h2.126v2.057A5.21 5.21 0 0 0 16.55 28V16.514a.995.995 0 0 0-.995-.994Z",
        fill: "url(#JiraDisabled_svg__b)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "JiraDisabled_svg__a",
        x1: 22.037,
        y1: 9.773,
        x2: 17.12,
        y2: 14.842,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.176,
        stopColor: "#344563"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#7A869A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "JiraDisabled_svg__b",
        x1: 16.643,
        y1: 15.564,
        x2: 10.959,
        y2: 21.094,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.176,
        stopColor: "#344563"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#7A869A"
    }))));
export default SvgJiraDisabled;
